import { integrationsClient } from '~/api/client';
import { endpoints } from '~/api/endpoints';
import type { ApiResponse } from '~/features/onboarding/types/connection.types';

import type {
  AnalyticsSyncRequest,
  AnalyticsSyncStatusResponse,
  AnalyticsSyncTriggerResponse,
} from '../types/analytics-sync.types';

/** Start an analytics ingestion workflow for one connection. Returns the
 *  `workflowId` we then poll via `getAnalyticsSyncStatus`. */
export async function startAnalyticsSync(
  body: AnalyticsSyncRequest,
): Promise<AnalyticsSyncTriggerResponse> {
  const res = await integrationsClient
    .post(endpoints.analyticsSync.trigger(), { json: body })
    .json<ApiResponse<AnalyticsSyncTriggerResponse>>();
  return res.data;
}

/** Poll an ingestion workflow's status + live progress. Reuses the shared
 *  `workflows/{id}/status` endpoint; returns the terminal state once done. */
export async function getAnalyticsSyncStatus(
  workflowId: string,
): Promise<AnalyticsSyncStatusResponse> {
  const res = await integrationsClient
    .get(endpoints.workflows.status(workflowId))
    .json<ApiResponse<AnalyticsSyncStatusResponse>>();
  return res.data;
}
